import privacy from '@/locales/zh/privacy'
import termsOfService from '@/locales/zh/terms-of-service'
import spacialRules from '@/locales/zh/spacial-rules'
import protocol from '@/locales/zh/protocol'
import kycPrivacy from '@/locales/zh/kyc-privacy'
import serviceCertification from '@/locales/zh/service-certification'

const zh = {
  Username: '用户名',
  Password: '密码',
  login_email: '登录邮箱',
  login_password: '登录密码',
  no_account: '没有账号？',
  forget_password: '忘记密码？',
  go_to_register: '去注册',
  log_in: '登录',
  phone_number: '手机号码',
  please_enter_phone_number: '请输入手机号码',
  please_enter_a_new_phone_number: '请输入新手机号码',
  get_code: '获取验证码',
  not_my_number: '不是我的号码',
  log_out: '退出登录',
  group_of_companies: '集团公司',
  log_out_tips: '由于长时间未操作，您已被登出',
  okay: '确定',
  sms_verification_code: '短信验证码',
  settings: '设置',
  profile: '个人资料',
  transaction_list: '交易记录',
  transaction_detail: '交易详情',
  fee: '手续费',
  blue_pay_balance: 'BluePay余额',
  balance: '余额',
  bluepay_balance: 'BluePay余额',
  available_balance: '可用余额',
  reserve_balance: '留存金额',
  withdrawable_balance: '可提现余额',
  more_info: '更多信息',
  transferable_balance: '可转账余额',
  available_amount: '可用金额',
  top_up_method: '充值方式',
  estimated_fee: '预估手续费',
  view_detail: '查看详情',
  step: '步骤',
  add_bank_card: '添加银行卡',
  bank_card_detail: '银行账户详情',
  bank: '银行',
  account_name: '账户名称',
  account_id: '账号',
  mobile_phone_number: '手机号码',
  save: '保存',
  del_bankcard: '解除绑定',
  my_conected_bank_accounts: '银行账户',
  bank_card_limit_1: '暂不支持解绑最后一个银行账户',
  bank_card_limit_5: '最多可添加5张银行卡',
  del_this_bank: '确认解绑该账户',
  submit: '提交',
  complete: '完成',
  next: '下一步',
  id_card: '身份证',
  passport: '护照',
  other: '其他',
  transaction_date: '交易日期',
  nationality: '国籍',
  first_name: '名字',
  last_name: '姓氏',
  id_type: '证件类型',
  reason: '原因',
  type: '类型',
  card_id: '证件号码',
  laser_id: '身份证背面编码',
  resubmit: '重新提交',
  authentication_failed: '身份信息认证失败，请重试',
  dyna_upload_id_portrait_missing: '未识别到证件照图像',
  industry: '职业',
  clear: '清除',
  date_of_birth: '出生日期',
  handwritten_signature: '手写签名',
  id_card_address: '省份、区县、街道',
  street_address: '详细地址',
  confirm: '确认',
  total_amount: '总金额',
  amount_to_be_paid: '支付金额',
  logout_account: '退出账户',
  upload_avatar: '上传头像',
  identity_information: '身份信息',
  bank_account: '银行账户',
  promotion: '促销活动',
  mobile_top_up_discount_promo: '话费充值折扣活动',
  expiration: '有效期',
  use_now: '立即使用',
  selected: '已选择',
  use_conditions: '使用条件',
  unavailable_reason: '不可用原因',
  close_tip: '活动已结束',
  useAble_tip: '超出促销活动限额',
  off: '关闭',
  unlink: '解除关联',
  notifications: '通知',
  transaction_number: '交易编号',
  problem_description: '问题描述',
  submission_time: '提交时间',
  customer_complaint_type: '问题类型',
  feedback_and_complaint: '反馈建议',
  view_more: '查看更多',
  history: '历史记录',
  proceed: '继续',
  select: '选择',
  bank_name: '银行名称',
  bank_account_no: '银行账号',
  bank_account_holder: '银行账户持有人',
  copy_of_bank_passbook_wallet: '银行存折/电子钱包复印件',
  old_password: '旧密码',
  new_password: '新密码',
  confirm_password: '确认密码',
  filter: '筛选',
  status: '状态',
  reset: '重置',
  channel: '渠道',
  transaction_type: '交易类型',
  details: '详情',
  amount: '金额',
  mobile_no: '手机号码',
  select_amount: '选择金额',
  method: '支付方式',
  account_number: '账户号',
  cash_out_fee: '提现手续费',
  amount_to_receive: '到账金额',
  detail_confirmation: '详情确认',
  tips: '提示',
  transaction_details: '交易详情',
  max_size_tips: '图片大小不能超过20M',
  upload_proof: '上传凭证',
  upload: '上传',
  up_to: '最高',
  download: '下载',
  top_up_amount: '充值金额',
  mobile_top_up_amount: '话费充值金额',
  discount_amount: '折扣金额',
  discount: '折扣',
  date_and_time: '日期和时间',
  top_up_fee: '充值手续费',
  copied: '已复制！',
  thai_qr_code: 'Thai QR',
  payment_successful: '支付成功',
  transaction_processing: '交易处理中',
  transaction_fee_included: '包含手续费：',
  transaction_fee: '交易手续费',
  payment_channel: '支付渠道',
  transaction_id: '交易ID',
  create_time: '创建时间',
  complete_time: '完成时间',
  payer: '付款方',
  payer_bank: '付款方银行',
  payer_account: '付款方账号',
  payer_account_name: '付款方账户名称',
  send_to: '发送至',
  no_more: '没有更多了',
  all: '全部',
  effective: '有效',
  expired: '已过期',
  closed: '已关闭',
  unavailable: '不可用',
  balance_change_details: '余额变动明细',
  voucher: '凭证',
  replies: '回复',
  receipt: '凭证',
  view: '查看',
  camera: '相机',
  album: '相册',
  processing: '待处理',
  success: '成功',
  failed: '失败',
  waiting: '等待中',
  top_up_success: '充值成功',
  top_up_failed: '充值失败',
  top_up_processing: '充值处理中',
  cash_out_success: '提现成功',
  cash_out_failed: '提现失败',
  cash_out_processing: '提现处理中',
  transfer_out_success: '转账成功',
  transfer_out_failed: '转账失败',
  transfer_out_processing: '转账处理中',
  mobile_top_up_success: '话费充值成功',
  mobile_top_up_failed: '话费充值失败',
  mobile_top_up_processing: '话费充值处理中',
  replicating_fail: '复制失败',
  replicating_success: '复制成功',
  submit_successfully: '提交成功',
  current_audit_status: '当前审核状态',
  remark: '备注',
  amount_unpaid: '未付金额',
  amount_paid: '已付金额',
  id_photos: '证件照片',
  upload_a_photo: '上传手持证件自拍照',
  signature: '签名',
  clear_signature: '清除签名',
  view_guidelines: '查看指南',
  id_number: '证件号码',
  overview: '概览',
  collapse: '收起',
  expand: '展开',
  pay: '支付',
  view_payment_history: '查看支付历史',
  delivery_bills_amount_due: '运费账单到期未支付金额',
  delivery_bills_unpaid_amount: '运费账单未付金额',
  cod_settlement_bills: 'COD账单结算金额',
  delivery_bills_paid_amount: '运费账单已付金额',
  delivery_bills_total_amount: '运费账单总金额',
  cod_settlement_bills_total_amount: 'COD账单总金额',
  cod_settlement_bills_paid_amount: 'COD账单已付金额',
  payment_complete: '支付完成',
  checkout_paid_history: '查看已支付历史',
  ver_code: '验证码',
  please_make_sure_the_information_correct: '请确认以上信息正确。提交的交易不可撤销。',
  dialog_verification_title: '需要验证',
  dialog_verification_content: '请完成您的身份验证以继续。',
  dialog_no_my_phone_content: '请联系J&T更新您的手机号码',
  close: '关闭',
  i_have_read: '我已阅读、理解并接受',
  privacy_policy: '隐私政策',
  terms_and_conditions: '条款与条件',
  the_special_rules_for_user: 'J&T 钱包功能特别规则',
  special_rules: '《J&T 钱包功能特别规则》',
  start_verification: '开始验证',
  global_jet_express: 'Global Jet Express',
  and_the_following: '及以下',
  companies: '公司',
  payments_tips: '款项将自动扣除，您将收到通知而无需进一步验证。',
  payments_details_tips: '付款详情将发送至您的Bluepay钱包。请查看交易记录获取更新。',
  agree_gray: '激活自动代扣即表示您同意',
  agree_red: '支付授权服务协议',
  account_settings: '账户设置',
  auto_debit_activate: '自动代扣激活',
  auto_debit: '自动代扣',
  bluepay_account_id: 'Bluepay账号',
  payment_method: '支付方式',
  termination_completed: '终止完成',
  jt_1: 'Global Jet Express',
  jt_2: '（泰国）有限公司',
  payment_details: '付款详情',
  auto_debit_tip_1: '款项将自动扣除，您将收到通知而无需进一步验证',
  auto_debit_tip_2: '自动代扣付款信息将通过Bluepay钱包通知。请查看交易记录获取详情。',
  auto_debit_terminate: '终止自动代扣',
  terminate_auto_debit: '自动代扣已终止',
  protocol_1: '支付授权服务协议',
  protocol_2: '获取更多信息或有疑问',
  protocol_3: '激活自动代扣即表示您同意',
  protocol_4: '访问',
  activation_successful: '激活成功',
  terminate_tip_1: '确认要终止自动代扣付款吗？',
  terminate_tip_2: '这将停止未来所有对该商户的自动代扣付款',
  enter_verification_code: '输入验证码',
  activation_date_time: '激活日期和时间',
  termination_date_time: '终止日期和时间',
  merchant: '商户',
  authorization_has_been_completed: '授权已完成',
  auto_debit_payment_method: '自动代扣支付方式',
  bill_type: '账单类型',
  bill_status: '账单状态',
  create_date: '创建日期',
  bill_amount: '账单金额',
  bill_paid_amount: '账单已付金额',
  bill_number: '账单编号',
  merchant_order_id: '商户订单ID',
  bill_final_payment_date: '账单最终付款日期',
  bill_create_time: '账单创建时间',
  bill_complete_time: '账单完成时间',
  clear_status: '销账状态',
  clear_amount: '销账金额',
  clear_reference_number: '销账参考号',
  related_transaction_id: '关联交易ID',
  related_wallet_transaction_id: '关联钱包交易ID',
  clear_type: '销账类型',
  clear_create_time: '销账创建时间',
  clear_complete_time: '销账完成时间',
  merchant_name: '商户名称',
  transfer_amount: '转账金额',
  receiver_account: '收款账户',
  receiver_account_name: '收款账户名称',
  transfer_out_fee: '转账手续费',
  upload_id: '上传证件',
  face_recognition: '人脸识别',
  dyna_face_scan_ready_title: '准备开始扫描您的面部',
  dyna_face_scan_tips_title: '人脸扫描提示',
  dyna_face_scan_tip_1: '请确保您处于光线充足的环境',
  dyna_face_scan_tip_2: '请将面部置于取景框内',
  dyna_face_scan_tip_3: '请等待几秒钟完成自动扫描',
  dyna_face_scan_tip_4: '扫描时请勿佩戴口罩',
  dyna_face_scan_tip_5: '请保持睁眼并注视摄像头',
  dyna_face_scan_cta: '开始扫描',
  dyna_face_scan_illustration_alt: '人脸扫描引导占位图',
  dyna_face_scan_config_missing: 'LiveWeb 人脸识别尚未配置，请先补充 account_id 和 app_key。',
  dyna_face_scan_image_fetch_failed: '获取最佳人脸图像失败，请重新扫描。',
  dyna_face_scan_image_timeout: '获取最佳人脸图像超时，请重新扫描。',
  dyna_face_scan_image_not_found: '当前请求未查询到匹配的人脸图像结果。',
  dyna_face_scan_image_cache_expired: '人脸图像缓存已过期，请重新发起扫描。',
  dyna_face_scan_image_auth_failed: 'LiveWeb 图像接口鉴权失败，请检查 account_id 和 app_key。',
  open_camera: '开启摄像头',
  face_tips: '请使用摄像头继续',
  confirm_information: '确认信息',
  id_card_information: '证件信息',
  en_first_name: '英文名',
  full_name: '姓名',
  en_last_name: '英文姓氏',
  laser_number: '身份证背面编码',
  date_of_issue: '证件签发时间',
  date_of_Expire: '证件过期时间',
  additional_information: '补充信息',
  monthly_income: '月收入',
  email: '邮箱',
  Verifying_your_identity: '正在验证您的身份...',
  This_may_take_a_few_seconds: '可能需要几秒钟，请勿关闭应用',
  Facial_Recognition_Failed: '人脸识别失败',
  Make_sure_your_face_is_centered: '请确保面部居中且光线充足后重试',
  Try_Again: '重试',
  Return: '返回',
  register_address: '注册地址',
  Country: '国籍',
  Sex: '性别',
  Issuing_State: '签发国家',
  MALE: '男',
  FEMALE: '女',
  Current_Address: '现居地址',
  Street_Address: '详细街道地址',
  Address_Details: '地址详情',
  Work_Location: '工作地址',
  Work_Street_Address: '详细街道地址',
  Occupation: '职业',
  Wallet_Usage_Purpose: '使用钱包的用途',
  Upload_Selfie_with_ID: '上传手持身份证照片',
  dyna_upload_id_subtitle: '请确保光线充足，并清晰展示您的身份证件。',
  dyna_upload_id_front_side: '证件正面',
  dyna_upload_id_back_side: '证件背面',
  dyna_upload_passport_page: '护照信息页',
  dyna_upload_id_privacy_notice: '我们将依据泰国法律保护您的个人信息',
  Daily_Expenses_Payments: '日常消费/支付',
  Money_Transfer: '转账',
  Bill_payment: '账单支付',
  Investment_Savings: '投资/储蓄',
  Donations_Charity: '捐赠/慈善',
  Online_Shopping_E_Commerce: '网购/电商',
  Business_Merchant_Services: '商业/商户服务',
  Clear_Signature: '清除签名',
  ID_Front: '身份证正面',
  ID_Back: '身份证背面',
  Selfie_with_ID: '手持身份证自拍',
  Please_enter_the_correct_email_address: '请输入正确的邮箱地址',
  Please_enter_the_correct_identification: '请输入正确的身份证号码',
  Please_enter_the_correct_Laser_ID: '请输入正确的身份证背面编码',
  Purpose_Description: '用途说明',
  Please_enter_the_correct_information_required_address: '门牌号、组、巷、路、邮政编码',
  Please_enter_the_correct_information_required: '请按要求输入正确信息。',
  confirm_submit:
    '提交成功。您的信息正在审核中。我们的工作时间为8:00至22:00，您的信息将在工作时间1小时内处理。如需帮助，请发送电子邮件至我们的客户支持：onboard@bluepay.asia',
  permission_request_title: '申请权限',
  Please_agree_to_the_camera_permission: '请同意相机权限',
  camera_permission_required_for_verification:
    '为了完成当前身份核验，我们需要获取您的相机权限，用于进行人脸识别或拍摄证件照片并完成 OCR 识别。若您不授权相机权限，系统将无法采集核验所需信息，当前流程将无法继续，您也无法进入下一步。',
  how_to_take_a_selfie_with_your_id: '如何拍摄手持证件自拍照：',
  how_to_take_a_selfie_tips_1: '1. 将有效身份证件置于脸部旁边。',
  how_to_take_a_selfie_tips_2: '2. 确保面部和证件清晰可见。',
  how_to_take_a_selfie_tips_3: '3. 使用纯色背景且光线充足的环境。',
  how_to_take_a_selfie_tips_4: '4. 摘掉口罩、帽子或墨镜。',
  how_to_take_a_selfie_tips_5: '5. 确保证件信息无模糊或遮挡。',
  got_it: '明白了',
  account_activated: '账户已激活！',
  account_activated_content: '成功！您的身份信息已验证。您现在可以使用账户进行充值、提现和转账。',
  I_agree_to_the: '我同意',
  kyc_service_agreement_certification: 'KYC流程隐私政策',
  Upload_proof_of_employment: '上传工作证明',
  Top_Up_Toast: '我们正在审核您的信息。审核通过后，您将可以进行充值。',
  Cash_Out_Toast: '我们正在审核您的信息。审核通过后，您将可以进行提现。',
  Transfer_Toast: '我们正在审核您的信息。审核通过后，您将可以进行转账。',
  mobile_top_up_Toast: '我们正在审核您的信息。审核通过后，您将可以进行话费充值。',
  job_title: '职位',
  Official_Workplace: '正式工作地址',
  Failure_Reason: '失败原因',
  Foreigner: '外国人',
  Thailand: '泰国',
  face_title_text: '请使用正确的证件类型',
  face_tip_text: '泰国国民只能使用国民身份证进行验证。请上传正确的证件并重试。',
  fee_waived: '手续费由J&T承担',
  expected_deposit_time: '预计到账时间',
  two_work_hours: '2个工作小时',
  failure_reason: '失败原因',
  proof_of_transfer: '转账凭证',
  per_top_up_limit: '单次充值限额',
  daily_remaining: '当日剩余限额',
  monthly_remaining: '当月剩余限额',
  issue_date_later_than_expiration_date: '证件到期日期必须晚于签发日期。',
  // MapString
  top_up_method_1: '银行转账',
  top_up_method_2: 'Thai QR',
  transaction_type_1: '充值',
  transaction_type_2: '话费充值',
  transaction_type_3: '提现',
  transaction_type_4: '话费充值失败',
  transaction_type_5: '提现失败',
  transaction_type_6: '转入',
  transaction_type_7: '自动代扣',
  transaction_type_8: '转账',
  transaction_type_11: '转账失败',
  transaction_status_1: '待处理',
  transaction_status_2: '成功',
  transaction_status_3: '失败',
  identity_audit_status_1: '待审核',
  identity_audit_status_2: '已通过',
  identity_audit_status_3: '已拒绝',
  feedback_type_1: '充值问题',
  feedback_type_2: '话费充值问题',
  feedback_type_3: '提现问题',
  feedback_type_4: '登录问题',
  feedback_type_5: '密码问题',
  feedback_type_6: '提交身份信息问题',
  feedback_type_7: '自动代扣问题',
  feedback_type_8: '转入问题',
  feedback_type_9: '添加银行卡问题',
  feedback_type_10: '转账问题',
  feedback_type_11: '账户注销问题',
  feedback_type_12: '其他问题',
  feedback_type_16: '支付PIN码锁定问题',
  payment_method_1: '余额',
  auto_debit_status_1: '已激活',
  auto_debit_status_2: '已终止',
  notify_type_1: '自动代扣激活通知',
  notify_type_2: '自动代扣终止通知',
  notify_type_3: '自动代扣成功',
  notify_type_4: '反馈与投诉回复',
  bills_status_1: '待处理',
  bills_status_2: '处理中',
  bills_status_3: '已完成',
  bills_status_4: '取消处理中',
  bills_status_5: '已取消',
  bills_type_1: 'COD账单',
  bills_type_2: '运费账单',
  consumption_type_1: '支付',
  limit_level_type_1: '钱包余额限额',
  limit_level_type_2: '每日充值限额',
  limit_level_type_3: '每月充值限额',
  limit_level_type_4: '每日消费交易限额',
  limit_level_type_5: '每月消费交易限额',
  limit_level_type_6: '每日转账/提现限额',
  limit_level_type_7: '每月转账/提现限额',
  limit_level_type_8: '每日转入限额',
  limit_level_type_9: '每月转入限额',
  limit_level_content_1: 'Bluepay钱包可持有的最大金额',
  limit_level_content_2: 'Bluepay钱包每日可充值的最大金额',
  limit_level_content_3: 'Bluepay钱包每月可充值的最大金额',
  limit_level_content_4: 'BluePay钱包每日累计可以支付的最大金额',
  limit_level_content_5: 'BluePay钱包每月累计可以支付的最大金额',
  limit_level_content_6: 'BluePay钱包每日可转账或提现的最大金额',
  limit_level_content_7: 'BluePay钱包每月可转账或提现的最大金额',
  limit_level_content_8: 'Bluepay钱包每日可转入的最大金额',
  limit_level_content_9: 'Bluepay钱包每月可转入的最大金额',
  // SentenceString
  agree_policy: '我已同意隐私协议和服务条款',
  enter_phone_number: '+66 请输入您的电话号码',
  phone_is_required: '电话号码为必填项',
  enter_password: '输入密码',
  enter_new_password: '输入新密码',
  confirm_new_password: '确认新密码',
  question_tip: '对此订单有疑问？',
  question_tip_2: '添加银行卡遇到问题？',
  login_with_password: '密码登录',
  login_with_code: '验证码登录',
  change_login_password: '修改登录密码',
  service_and_help: '客户支持',
  tip_transfer_corresponding_amount_account: '您需要向该账户转账对应金额：',
  tip_upload_proof_transfer: '请上传您的转账凭证：',
  confirm_submit_transaction_tip: '请确认以上信息正确，提交的交易不可撤销',
  this_field_is_required: '此字段为必填项',
  please_enter_the_correct_name_format: '请输入正确的姓名格式',
  password_inconsistency: '两次密码输入不一致',
  select_top_up_method: '选择充值方式',
  receiving_bank_account: '收款银行账户',
  enter_amount: '输入金额',
  please_enter_9_digits: '请输入9位数字和字母',
  please_enter_12_digits_or_letter: '请输入12位数字和字母',
  please_enter_13_digits: '请输入13位数字',
  please_enter_least_6_digits_or_letter: '请输入6~9位数字或字母',
  laser_id_valid_tips: '只能输入数字、字母和-，不超过20位',
  upload_front_photo_id: '上传身份证正面照片',
  q_1: '如何登录Bluepay应用？',
  a_1: '登录Bluepay应用步骤：下载安装应用→打开应用→在注册页面选择"登录"→输入注册手机号和对应密码→点击"登录"按钮完成登录',
  q_2: '如何在应用内充值？',
  a_2: '应用内充值步骤：在应用首页找到"充值"入口→选择充值方式(如银行卡等)→输入充值金额并确认信息→根据支付方式完成支付→充值成功后账户余额将自动更新',
  q_3: '如何从应用提现？',
  a_3: '提现步骤：在应用首页找到"提现"入口→输入提现金额并确认信息→选择提现方式(通常支持银行卡等)→提交提现申请→审核通过后金额将转入指定账户',
  q_4: '如何使用应用充值手机话费？',
  a_4: '话费充值步骤：在应用首页找到"话费充值"入口→输入手机号和充值金额→选择支付方式完成支付→充值成功后手机话费将自动到账',
  upload_back_photo_id: '上传身份证背面照片',
  handheld_id_photo: '上传手持身份证照片',
  uploading_with_dot: '上传中...',
  loading_with_dot: '加载中...',
  view_history: '查看历史记录',
  enter_personal_info_bank_info: '请完善个人验证信息和银行信息',
  feedback_sent_success: '反馈提交成功',
  please_enter: '请输入',
  please_sselect_your_region: '请选择您所在的地区',
  pls_enter_10_num: '请输入10位数字',
  input_value_cannot_spaces: '输入值不能包含空格',
  please_enter_two_decimal: '请输入最多2位小数的非负数',
  please_enter_non_negative_number: '请输入非负数',
  please_sign_by_hand: '请手写签名',
  please_enter_non_zero_number: '请输入非零整数',
  please_enter_two_decimal_places: '请输入两位小数',
  please_enter_9_19_digits: '请输入9-19位数字',
  please_check_info_correct: '请检查信息填写是否正确',
  there_are_unfilled_fields: '存在未填写的字段',
  valid_password_tips: '8-15个字符，包含字母、数字和符号组合',
  please_enter_0_or_9_digits_phone_number: '请输入0+9位数字/输入9位电话号码',
  // 'privacy_sentence1': 'BluePay Company Limited (the "Company") realizes the importance of the privacy and the personal data protection of the Company\'s customers and clients (collectively called as "you"). Thus, the Company has established the Privacy Policy and to notify you regarding the Company\'s guideline for the collection, use and disclosure of personal data in order to enable you to confidently use electronic money service via BluePay  application (the "Application"), payment service, money transfer service via electronic methods and other services as approved by Bank of Thailand, which are currently available and may be available in the future, including but not limited to any services relating to the usage of applications, websites and other channels provided by the Company (collectively called as the "Services").',
  // 'privacy_title1': 'Personal Data',
  // 'privacy_sentence2': '"Personal Data" means the information relating to a person, which enables the identification of such person, whether directly or indirectly, but not including the information of the deceased persons in particular, such as name-surname, identification card number, address, telephone number, financial transaction.',
  // 'privacy_sentence3': 'Personal Data may consist of sensitive information and at risk of being treated unfairly (Sensitive Personal Data) such Personal Data includes but not limited to biometrics data, data relating to religious.',
  // 'privacy_sentence4': 'In this regard, such Personal Data includes any information provided by you to the Company and/or being in the Company\'s possession and/or lawfully collected by the Company from any other sources or any other persons.',
  // 'privacy_sentence5': 'In case where necessary for the Company to collect, use or disclose your Personal Data which is out of the scope as specified in this Privacy Policy, the Company will inform you regarding such different characteristics at the time or prior to the collection, use or disclosure of your Personal Data.',
  // 'privacy_sentence6': 'By using the Services, it is considered that you have read and understood this Privacy Policy. Otherwise, please immediately stop using the Service.',
  // 'privacy_title2': 'Type of Personal Data Collected, Used or Disclosed by the Company',
  // 'privacy_sentence7': 'Information on identification card, passport and/or other evidence issued by government authorities such as identification card number, name, surname, name prefix, signature;',
  // 'privacy_sentence8': 'Necessary contact information such as contactable address, telephone number;',
  // 'privacy_sentence9': 'Particular personal characteristics such as status, biometrics data, photo;',
  // 'privacy_sentence10': 'Education and/or career information;',
  // 'privacy_sentence11': 'Financial information such as records of transactions made through BluePay accounts or other Services, credit card information, deposit account information;',
  // 'privacy_sentence12': 'Information relating to your devices, system, and usage behaviors, including but not limited to device identity number in relation to network connection (such as IP address, MAC address, Device ID), Advertisement ID, mobile device operating systems, mobile network service provider, location, device usage details, cookies, phonebook, application usage, technical information, model and type of devices, photo, image and photo album .',
  // 'privacy_sentence13': 'For the necessity of providing additional services apart from fundamental Services or the collection, use, disclosure of Sensitive Personal Data other than those specified above, the Company will perform the processing under legal basis as prescribed by law only. In this regard, the Company will inform the purpose and type of Personal Data required to be collected, used or disclosed prior to or at the time of such processing.',
  // 'privacy_title3': 'Basis of the Collection, Use and Disclosure of your Personal Data and the Purposes of such Processing',
  // 'privacy_sentence14': 'The Company will collect, use or disclose your Personal Data under legal basis and in accordance with the following purposes:',
  please_enter_less_amout_than_balance: '请输入小于可用余额的金额',
  please_enter_less_amout_than_withdraw_balance: '请输入小于可提现余额的金额',
  please_enter_less_amount_than_transferable_balance: '请输入小于可转账余额的金额',
  submit_bank_info_tips: '确认银行卡信息是否正确？',
  delete_bank_info_tips: '确认要注销此账户吗？',
  insufficient_balance: '余额不足',
  reserve_balance_note: '留存金额说明：',
  overview_help: '总览帮助',
  delivery_bills_unpaid_amount_tips: '- 指待支付运费账单的总金额',
  delivery_bills_amount_due_tips: '- 指您运费账单到期未支付的总金额',
  cod_settlement_bills_tips: '- 指J&T代收客户的COD账单结算金额',
  delivery_bills_paid_amount_tips: '- 指您已支付的运费账单总金额',
  delivery_bills_total_amount_tips: '- 指已生成运费账单的总金额',
  the_fund_reserve_for_paying_delivery_bills:
    '该金额为需要支付的运费账单总金额，资金仅能用于支付运费账单，不可提现。如有疑问请联系J&T',
  the_fund_frozen_for_paying_delivery_bills:
    '该金额为需要支付的运费账单总金额，资金仅能用于支付运费账单，不可转出。如有疑问请联系J&T',
  valid_bank_phone: '必须大于6位数字',
  topup_mobile_tips: '交易金额已超限，请完善身份信息继续交易',
  services: '服务商',
  pay_in_qr_tips: '截图(推荐)/下载二维码，使用以下任一应用完成支付',
  qr_screen_or_download: '请截图或者复制下载链接到浏览器打开，以保存二维码，并使用支持的支付APP扫码完成付款。',
  copy_download_link: '复制下载链接',

  pay_in_qr_tips_jt: '截图/下载二维码，使用对应应用完成支付',
  screen_qr_jt: '请截图保存二维码，并使用支持的支付APP扫码完成付款。',
  you_have: '您有',
  unread_messages: '条未读消息',
  are_you_sure_to_submit: '确认提交吗？',
  up_to_5_images_can_be_uploaded: '最多可上传5张图片',
  wallet_balance_limit: '钱包余额限额',
  wallet_balance_limit_content: '每日可存入钱包的总金额（含充值和转入）',
  unauthorized: '未认证',
  basic_account: '基础认证账户',
  semi_verified: '部分认证账户',
  fully_verified: '高级认证账户',
  view_benefits: '查看权益',
  verify_account: '升级账户',
  why_we_require_verification: '为何需要验证',
  verification_reason: '为遵守泰国央行规定并保护资金安全，BluePay采用分等级账户验证制度并设置相应交易限额',
  verification_reason_jt:
    '为遵守泰国央行规定并保护资金安全，J&T钱包采用分等级账户验证制度并设置交易限额。这些要求有助于：',
  verification_help: '这些要求有助于：',
  why_are_account_tiers_important: '账户分级的重要性',
  important_reason:
    '根据泰国《支付系统法》及《反洗钱法规》，电子钱包必须验证用户身份(KYC)并依据账户风险等级设置交易限额',
  prevent_financial_crimes: '预防金融犯罪(欺诈、洗钱)',
  secure_your_account: '保障账户安全',
  ensure_safe: '确保支付服务安全合规',
  account_features: '账户功能',
  account_type: '账户类型',
  view_balance: '查看余额',
  cash_in: '转入',
  payment: '支付',
  transaction_history: '交易记录',
  receive_money: '收款',
  send_money: '转账',
  age_more_than_15: '15岁及以上用户',
  age_lest_than_15: '15岁以下用户',
  non_thai_id_card: '非泰国身份证用户',
  wallet_balance: '钱包余额',
  wallet_dialog_confirm: '升级我的账户',
  wallet_dialog_title: '达到钱包限额',
  warn_dialog_title: '钱包限额提醒',
  dismiss: '忽略',
  wallet_dialog_content_left: '交易金额超过收款方单笔收款限额(最高：฿',
  wallet_dialog_content_right: ')，请减少金额',
  warn_dialog_content_left: '您已达到BluePay余额上限',
  warn_dialog_content_right: '请先消费或转账后再存入',
  per_transaction: '单笔交易',
  daily_cumulative: '日累计',
  monthly_transaction: '月累计',
  consumption: '消费',
  transfer_out: '转账',
  transfer_in: '转入',
  unlimited: '无限制',
  please_upload_supporting_documents: '请上传辅助证件',
  upload_image_here: '在此上传图片',
  please_upload_you_information: '请确认您的信息',
  laser_umber: '身份证背面编码',
  service_agreement_certification: '隐私政策与信用额度提升流程',
  could_not_complete_verification: '验证未完成',
  could_not_complete_verification_content_1: '提交信息存在问题：',
  could_not_complete_verification_content_2: '请更新信息后重试',
  try_again: '重试',
  submit_for_manual: '提交人工审核',
  auth_failed: '认证失败',
  failed_reason: '存在问题：',
  upload_photo: '上传照片',
  upload_photo_tips: '您的信息已上传，正在审核中',
  dopa_status_tips: '账户升级成功，现已开放全部功能并提高交易限额',
  in_review: '审核中',
  supporting_documents: '辅助材料',
  left: '剩余',
  used_out_of: '已使用/总计',
  dopa_success: '验证成功！',
  dopa_success_content: '账户升级成功，现已开放全部功能并提高交易限额',
  dopa_review: '您的信息正在审核中',
  dopa_review_content1: '我们工作时间为8:00-22:00，您的提交将在1小时内处理',
  dopa_review_content2: '如需帮助，请联系客服邮箱：',
  you_can_upload_up_to_5_supporting_documents: '最多可上传5份辅助材料',
  view_supported_guidelines: '查看支持的证件类型',
  supported_guidelines: '支持的证件类型',
  work_permit_related_documents: '工作许可相关文件',
  work_permit_book: '工作许可证(簿式)',
  work_permit_card: '工作许可证（卡）',
  work_permit_passport: '含有NON-B签证页的护照',
  work_permit_receipt: '工作许可凭证（副本或原件）',
  other_acceptable_documents: '其他可接受文件',
  other_thai_house: '泰国户籍簿',
  other_thai_driving: '泰国驾照',
  other_password_non: '护照含非移民签证',
  other_password_student: '护照含学生签证',
  other_alien_ident: '外国人身份证',
  tips_balance_l: 'Bluepay余额不能超过฿',
  tips_balance_r: '，请减少金额或先升级账户等级',
  tips_balance_r_highest: '，请减少金额或先进行消费',
  tips_single_l: '交易金额超过单笔支付限额(最高：฿',
  tips_daily_l: '当日支付总额已达฿',
  tips_amount_limit: '(限额：฿',
  tips_amount_remain: '，剩余：฿',
  tips_daily_r: ')，继续操作将超限。升级账户可提高限额',
  tips_tran_r_highest: ')，继续操作将超限。',
  tips_monthly_l: '当月支付总额已达฿',
  tips_monthly_r: ')，继续操作将超限。升级账户可提高限额',
  powered_by_bluepay: '由BLUEPAY提供技术支持',
  settle_shipments_quickly: '快速结算货款',
  with_j_t_bill: '使用J&T Bills轻松快速支付货款',
  document_expired: '证件已过期',
  document_expired_tips: '您提交的证件已过期，请上传有效证件后重试',
  top_up_two_tips_title: '处理时间说明',
  top_up_two_tips_1: '工作日(9:00am-3:00pm)：2小时内到账',
  top_up_two_tips_2: '非工作时间或周末：下一工作日10:00am前到账',
  // PageTitleString
  login: '登录',
  register: '注册',
  reset_password: '重置密码',
  privacy: '隐私协议',
  privacy_agreement: '隐私政策',
  terms_of_service: '服务条款',
  the_special_rules: '特殊规则',
  service_policy: '服务条款',
  bluepay_service_policy: 'BluePay 服务条款',
  language: '语言',
  faq: '常见问题',
  bank_accounts: '银行账户',
  help_center: '帮助中心',
  feedback: '意见反馈',
  feedback_history: '反馈记录',
  page_not_found: '页面未找到',
  new_account: '新账户',
  personal_information: '个人信息',
  top_up: '充值',
  cash_out: '提现',
  transfer: '转账',
  mobile_top_up: '话费充值',
  mobile_number: '手机号码',
  verification_code: '验证码',
  mobile_verification: '手机验证',
  update_mobile_number: '更新手机号',
  activate_auto_debit: '开通自动代扣',
  jt_bills: 'J&T账单',
  bill_details: '账单详情',
  bill_payment_history: '账单支付记录',
  bill_payment_detail: '账单支付详情',
  assets: '资产',
  transactions: '交易记录',
  home: '首页',
  account: '收款账户',
  inbox: '消息中心',
  account_limits: '账户限额',
  verification_levels: '验证等级',
  account_verification: '账户验证',
  you_have_no_data_yet: '暂无数据',
  feedback_successful:
    '感谢您成功提交反馈信息，我们已收到您的反馈，并会及时向您通报问题的处理进展。如有其他问题，欢迎通过以下方式联系我们：csr@bluepay.asia',
  cancel: '取消',
  no_promotions_available: '暂无可用优惠。',
  all_of_promos: '你所有的优惠将显示在此处',
  fee_prefix_cash_out: '免费提现剩余次数',
  fee_prefix_transfer_out: '免费转账剩余次数',
  this_month_0: '本月：0',
  this_week_0: '本周：0',
  today_0: '今日：0',
  total_remain: '（总计剩余：{a}/{x}）',
  this_week_month: '（本月剩余：{a}/{x}）',
  today_month: '（本月剩余：{a}/{x}）',
  today_week: '（本周剩余：{a}/{x}）',
  today_left: '今日：{x} 次',
  total: '{a}/{x} 次',
  cash_out_this_month_0_total: '本月免费提现剩余次数：0',
  cash_out_this_week_0_total: '本周免费提现剩余次数：0',
  cash_out_today_0_total: '今日免费提现剩余次数：0',
  cash_out_total: '免费提现剩余次数：{a}/{x}',
  cash_out_this_month_0: '本月免费提现剩余次数：0',
  cash_out_this_month_x: '本月免费提现剩余次数：{x}',
  cash_out_this_week_0_month_remain: '本周免费提现剩余次数：0',
  cash_out_this_week_0: '本周免费提现剩余次数：0',
  cash_out_this_week_x: '本周免费提现剩余次数：{x}',
  cash_out_today_0_month_remain: '今日免费提现剩余次数：0',
  cash_out_today_0_week_remain: '今日免费提现剩余次数：0',
  cash_out_today_0: '今日免费提现剩余次数：0',
  cash_out_today_x: '今日免费提现剩余次数：{x}',
  transfer_out_this_month_0_total: '本月免费转账剩余次数：0',
  transfer_out_this_week_0_total: '本周免费转账剩余次数：0',
  transfer_out_today_0_total: '今日免费转账剩余次数：0',
  transfer_out_total: '免费转账剩余次数：{a}/{x}',
  transfer_out_this_month_0: '本月免费转账剩余次数：0',
  transfer_out_this_month_x: '本月免费转账剩余次数：{x}',
  transfer_out_this_week_0_month_remain: '本周免费转账剩余次数：0',
  transfer_out_this_week_0: '本周免费转账剩余次数：0',
  transfer_out_this_week_x: '本周免费转账剩余次数：{x}',
  transfer_out_today_0_month_remain: '今日免费转账剩余次数：0',
  transfer_out_today_0_week_remain: '今日免费转账剩余次数：0',
  transfer_out_today_0: '今日免费转账剩余次数：0',
  transfer_out_today_x: '今日免费转账剩余次数：{x}',
  network_error_toast_1: '网络请求出错，请切换网络后重试！',
  network_error_toast_2: '登录信息已过期！',
  network_error_toast_3: '需要访问权限',

  transaction_proof: '流水证明',
  company_information: '公司信息',
  director_or_an_authorized: '您的身份是公司董事还是公司被授权人？',
  company_legal_name: '公司名称',
  product_service_description: '产品/服务描述',
  company_website: '公司官网',
  tax_identification_number: '税务登记号',
  dbd_document: 'DBD Document',
  primary_director_information: '主董事信息',
  authorized_person_information: '被授权人信息',
  valid_id_document: '证件图片',
  for_thai_nationals: '泰国公民：上传泰国身份证',
  for_foreigners: '外国人：上传护照',
  id_front_image: '证件正面照片',
  id_back_image: '证件背面照片',
  bank_account_proof: '银行账户文件',
  settlement_account_information: '结算银行账户信息',
  registered_address: '注册地址',
  business_address: '经营地址',
  director: '董事',
  authorized_representative: '被授权人',
  not_required_with_passport: '如已上传护照则无需此项',
  select_your_account_verification_type: '选择账户验证类型',
  enterprise: '企业用户',
  personal: '个人用户',
  registered_address_same_as_business_address: '注册地址与经营地址相同',
  document_upload_guidelines: '文件上传指南',
  document_upload_guidelines_content_1: '请上传清晰的DBD商业注册文件照片或扫描件',
  document_upload_guidelines_content_2: '仅用于身份验证，需显示公司名称和注册详情',
  auth_document_upload_guidelines_content_1: '可上传银行交易记录等财务凭证',
  auth_document_upload_guidelines_content_2: '这些文件仅用于注册身份验证',
  please_select_your_region: '请选择您所在的地区',
  download_template: '下载模板',
  download_template_img: '下载模板（图片格式）',
  download_template_pdf: '下载模板（PDF格式）',
  front_only: '仅正面',
  front_and_back: '正反面',
  thai_national_id_card: '泰国身份证',
  authorization_document: '被授权文件',
  please_select: '请选择',
  please_upload: '请上传',
  please_select_image: '请选择图片',
  enterprise_service_agreement_certification: '认证服务协议',
  please_confirm_that_your_id_type: '请确认您的证件类型：',
  Service_Agreement_Certification: '认证服务协议',
  personal_accounts: '对于个人用户',
  enterprise_accounts: '对于企业用户',
  for_thailand_enterprise: '对于泰国本地企业',
  add_bank_account: '+ 添加新的银行账户',
  document_need: '若注册人非公司董事，需提交本文件。',
  document_procedure: '操作指引：',
  copy_document_notice_1: '1.复制链接到浏览器中打开，下载模板',
  download_document_notice_1: '1.下载模板（支持 PDF/图片格式）',
  document_notice_2: '2.填写内容并加盖公章',
  document_notice_3: '3.扫描或拍照后上传（需文字清晰、印章可辨，支持 JPG/PNG 格式）',
  copy_success: '复制成功,请打开浏览器下载',
  copy_fail: '复制失败,请稍后重试',
  copy_template_link: '复制下载模板的链接',
  // 注销账户相关
  deactivate_account: '注销账号',
  pop_deactivate_title: '注销账号',
  pop_deactivate_account_content_start: '在您注销账号前，请仔细阅读以下注意事项：',
  pop_deactivate_account_content_1:
    '一旦选择注销账号，该账号及所有相关数据（包括个人信息、设置、历史记录等）将被永久删除，请慎重考虑。',
  pop_deactivate_account_content_2:
    '账号注销后将有90天冷却期，冷静期结束后您将无法再次登录应用。请确认您确实不再需要该账号及其数据。',
  pop_deactivate_account_content_3: '若在90天内登录应用，注销流程将中断，账号不会被注销。如需注销需重新发起流程。',
  pop_deactivate_account_content_4: '我们重视您的隐私与数据安全。账号注销后，我们将不再保留您的个人数据。',
  pop_deactivate_account_content_5:
    '如未来需要继续使用我们的服务，您需要重新注册新账号，原账号及数据将无法恢复。请在注销前确保已备份重要信息。如有任何疑问或需要协助完成账号注销流程，请联系我们的客服团队。',
  pop_deactivate_account_content_end: '感谢您选择我们的服务',
  cannot_be_deactivated: '你的账号无法注销',
  cannot_be_deactivated_title: '为保障您的资金和账户安全，您的账户目前无法注销，原因如下：',
  cannot_be_deactivated_content: '您的账户余额不为零。',
  ok: '好的',
  verify: '验证',
  exit: '退出',
  deactivate_successful: '注销申请已提交',
  deactivate_successful_title: '您的账号已进入90天注销等待期，将在90天后自动完成注销。',
  important_information_1:
    '一旦确认注销，该账号及所有相关数据（包括个人信息、设置、历史记录等）将被永久删除，请慎重考虑',
  important_information_2: '账号注销设有90天冷静期，到期后将无法再次登录。请确认您不再需要该账号及数据。',
  important_information_3: '若在90天内登录账号，注销流程将自动终止。如需注销需重新提交申请。',
  important_information_4: '我们高度重视您的隐私与数据安全，账号完成注销后将彻底删除所有个人数据。',
  important_information_5: '如需再次使用我们的服务，您需要重新注册新账号，原账号及数据将无法恢复。',
  verify_it_is_you: '验证您的身份',
  enter_your_phone: '请输入您的手机号码以接收验证码',
  account_recovery_reminder: '账号重新激活成功',
  account_reactivated_content: '您已经中断账号注销流程，您的账号已被重新激活',

  registrant_identity_confirmation: '注册人身份确认',
  proceed_to_verification: '前往验证',
  submit_success: '验证成功！ ',
  submit_success_content1: '您的信息已提交，正在审核中',
  submit_success_content2: '我们的团队在8:00至22:00处理申请，您的资料将在1小时内审核',
  submit_success_content3: '如有任何疑问，请随时联系我们：',
  enhanced_kyc_requires_verification: '高级KYC需验证注册人信息',
  please_confirm_that_you_are: '请确认您的身份：',
  top_up_time_toast: '工作时间2h内',
  continue: '继续',

  face_authentication: '人脸认证',
  verification_failed: '验证失败',
  verification_failed_tips: '认证失败。请确认姓名：{name}，证件号码：{id}。 如信息有误，请提交人工审核。',
  submit_for_manual_review: '提交人工审核',
  manual_review_request: '申请人工审核',
  select_reason_for_appeal: '请选择申诉原因：',
  incorrect_name_or_ID: '姓名/证件号码填写错误',
  incorrect_document_information: '证件信息有误',
  other_reasons: '其他原因',
  submit_request: '提交申请',
  set_up_pin: '设置PIN码',
  remind_me_later: '稍后提醒',
  pop_set_pin_content: '为更好地保护您的交易安全，请为账户设置PIN码。',
  issue_13_tips: '请上传您注册时使用的证件图片以及手持该证件照片。',
  face_required_tips: '设置支付PIN码需进行人脸识别。',
  otp_required_tips: '设置PIN码需要校验OTP。',
  create_your_pin_for: '请为您的账户设置6位数PIN码。',
  create_your_pin_confirm: '请确认您的6位数PIN码。',
  pin_no_match: 'PIN码不一致，请重新输入。',
  pin_setup_complete: 'PIN码设置完成',
  pin_setup_complete_content: '恭喜！PIN码设置完成。您的支付现在更加安全。',
  done: '完成',
  set_now: '立即设置',
  forgot_pin: '忘记PIN码?',
  user_face_pay: '使用人脸认证',
  enter_pin: '输入PIN码',
  enter_payment_pin: '请输入6位数PIN码。',
  please_complete_face: '为更好地保护您的交易安全，请完成人脸认证。',
  verification_code_to_phone: '请输入发送至您手机的验证码。',
  verify_old_pin: '验证旧PIN码',
  input_your_old_pin: '请输入您的旧PIN码',
  verify_with_old_pin: '使用旧PIN码验证',
  facial_authentication: '人脸识别验证',
  otp_verification: 'OTP验证',
  pin_verification_method: '为保障您的安全，请在设置新PIN码前先验证身份。请选择您的验证方式。',
  face_try_again_later: '人脸验证失败次数过多，功能已暂时锁定。请{time}分钟后再试。',
  not_now: '暂不处理',
  upgrade_to_unlock: '升级认证并解锁',
  forgot_to_unlock: 'PIN码错误尝试次数过多，账户已被锁定。请点击“忘记PIN码”按钮进行人脸识别以进行PIN码解锁。',
  upgrade_to_unlock_pin:
    'PIN码错误尝试次数过多，账户已被锁定。为保障账户安全，请完成升级认证。认证通过后，PIN码将自动解锁并为您提升交易额度。',
  upgrade_to_unlock_pin_in_audit:
    '您的PIN码重置及账户升级申请正在审核中。在审核完成前，您将无法发起交易。我们的团队在早8:00至晚10:00期间处理申请，并力争在此时间段内1小时内完成审核。如有任何疑问，请随时联系我们：onboard@bluepay.asia',
  please_complete_facial: '为更好地保护您的交易安全，请完成人脸认证。',
  your_facial_authentication_is_undergoing_review:
    '您的人脸认证正在审核中。在审核完成前，您将无法发起交易。我们的团队在早8:00至晚10:00期间处理申请，并力争在此时间段内1小时内完成审核。如有任何疑问，请随时联系我们：onboard@bluepay.asia',
  pin_must_be: 'PIN码须为6位数字，且不能为连续或重复数字。',
  face_fail_to_try_again: '人脸认证失败，请重试',
  pin_unlocked_successfully: 'PIN码解锁成功，您可以继续进行交易。',
  large_trans_tip: '大额交易需要进行人脸识别，为更好地保护您的交易安全，请完成账户升级认证。',
  pin_unlock_success: '您的PIN码重置和账户升级已经完成，可以继续进行交易。',
  ...privacy,
  ...termsOfService,
  ...spacialRules,
  ...protocol,
  ...kycPrivacy,
  ...serviceCertification
}

export default zh
